<template>
  <div class="container">
    <div style="width:900px;margin:40px auto;">
      <div class="flex-wrap flex-line"> <Input size="large" v-model="searchText" placeholder="输入材料名称/型号/品牌/厂家等关键字查询" />
        <Button type="primary" style="margin-left:10px" size="large" @on-enter="search" @click="search">
          <BaseIcon icon="md-search" />
          搜索
        </Button></div>
      <div class="flex-wrap split5" style="margin-top:30px;height:40px;padding:5px;">
        <template v-for="(t,i) in sub_types">

          <div :key="'t_'+t" style="cursor:pointer" :style="(!counts[t]?'filter:opacity(0.4)':'')+(selected == t?'color:var(--primary);font-weight:bold':'')" @click="selected = t;page=1;getData()">{{t}}({{counts[t] || 0}})</div>
          <Divider type="verticle" :key="'d_'+t" v-if="i != sub_types.length - 1" />
        </template>

      </div>

      <div class="" style="overflow-y:auto;height:calc(100% - 100px);min-height:600px;margin-bottom:10px;position:relative;background:var(--bg3);border:1px solid var(--border);">
        <template v-if="selected == '类别'">
          <Row  style="padding:5px 0;border-bottom:1px dashed var(--border);background:var(--bg2)" align="middle">
          <Col :span="3" align="center">
          序号</Col>
          <Col :span="21">
          名称</Col>
          </Row>
           <template v-for="(item,i) in items">
          <Row :key="item.id" style="margin:5px 0;padding:5px 0;border-bottom:1px dashed var(--border)" align="middle">
          <Col :span="3" align="center">{{i+1}}</Col>
        <Col :span="5">
        <a @click="RouteTo(`/core/materials/${item.id}/type`)">{{item.name}}</a>
        </Col>
      </Row>

        </template>
        </template>
        <template v-else-if="selected == '品牌'">
         <Row style="padding:5px 0;border-bottom:1px dashed var(--border);background:var(--bg2)" align="middle">
          <Col :span="3" align="center">
          图示</Col>
          <Col :span="5">
          品牌名</Col>
          <Col :span="4"  align="left">
          生产商</Col>
          <Col :span="5"  align="left">
          档次</Col>
          <Col :span="5" align="right">
          描述</Col>

         </Row>
        <template v-for="item in items">
          <Row :key="item.id" style="margin:5px 0;padding:5px 0;border-bottom:1px dashed var(--border)" align="middle">
          <Col :span="3" align="center">
        <img style="width:60px;height:60px;border-radius:5px;border:1px solid var(--border)" :src="item.avatar || 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/empty-img.png'" /></Col>
        <Col :span="5">
        <div>
        <div style="font-weight:bold"><a @click="RouteTo(`/core/materials/${item.id}/brand`)">{{item.name}}</a></div>
        <div style="color:var(--subtext3)">{{item.model}}</div>
        </div>
        </Col>
        <Col :span="4"  align="left" style="text-align:left">
        <template v-if="item.producer">
        <a class="flex-wrap flex-between" @click="RouteTo(`/core/materials/${item.producer.id}/company`)">
          <div>{{item.producer.name}}
            <div style="color:var(--subtext3)">{{item.producer.address}}</div></div>
        </a>
        </template>
        <span v-else>-</span>
        </Col>
        <Col :span="5"  align="left">
          {{item.level}}</Col>
          <Col :span="5" align="right">
          {{item.description}}</Col>
      </Row>

        </template>
        </template>
        <template v-else-if="selected == '材料'">
         <Row  style="padding:5px 0;border-bottom:1px dashed var(--border);background:var(--bg2)" align="middle">
          <Col :span="3" align="center">
          图示</Col>
          <Col :span="5">
          名称/型号</Col>
          <Col :span="4"  align="left">
          生产商</Col>
          <Col :span="2"  align="left">
          产地</Col>
          <Col :span="3" align="right">
          参考价</Col>
          <Col :span="3"  align="center">
          询价时间</Col>
          <Col :span="1"  align="center">
          收藏</Col>
         </Row>
        <template v-for="item in items">
          <Row :key="item.id" style="margin:5px 0;padding:5px 0;border-bottom:1px dashed var(--border)" align="middle">
          <Col :span="3" align="center">
        <img style="width:60px;height:60px;border-radius:5px;border:1px solid var(--border)" :src="item.avatar || 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/empty-img.png'" /></Col>
        <Col :span="5">
        <div>
        <div style="font-weight:bold"><a @click="RouteTo(`/core/materials/${item.id}/info`)">{{item.name}}</a></div>
        <div style="color:var(--subtext3)">{{item.model}}</div>
        </div>
        </Col>
        <Col :span="4"  align="left" style="text-align:left">
        <template v-if="item.producer">
        <a class="flex-wrap flex-between" @click="RouteTo(`/core/materials/${item.producer.id}/company`)">
          <div>{{item.producer.name}}
            <div style="color:var(--subtext3)">{{item.producer.address}}</div></div>
        </a>
        </template>
        <span v-else>-</span>
        </Col>
        <Col :span="2"  align="center">
        {{item.product_area}}</Col>
        <Col :span="3"  align="">
        <BaseAmount full :value="item.last_price?item.last_price.amount:0" />
        </Col>
        <Col :span="3"  align="center">
        {{item.last_price?moment(item.last_price.accquired_at).fromNow():'-'}}</Col>

          <Col :span="1"  align="center">
        <Button icon="md-add" @click="addToCart(item)"></Button></Col>
      </Row>

        </template>
        </template>
        <template v-else-if="selected == '商家'">
              <Row style="padding:5px 0;border-bottom:1px dashed var(--border);background:var(--bg2)" align="middle">
          <Col :span="3" align="center">
          图示</Col>
          <Col :span="9">
          名称</Col>
          <Col :span="10" align="left">
          描述</Col>

         </Row>
        <template v-for="item in items">
          <Row :key="item.id" style="margin:5px 0;padding:5px 0;border-bottom:1px dashed var(--border)" align="middle">
          <Col :span="3" align="center">
        <img style="width:60px;height:60px;border-radius:5px;border:1px solid var(--border)" :src="item.avatar || 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/empty-img.png'" /></Col>
        <Col :span="9">
        <div>
        <div style="font-weight:bold"><a @click="RouteTo(`/core/materials/${item.id}/company`)">{{item.name}}</a></div>
        <div style="color:var(--subtext3)">{{item.model}}</div>
        </div>
        </Col>
          <Col :span="10" align="left">
          {{item.description}}</Col>
      </Row>

        </template>
        </template>
         <BaseEmpty v-if="items.length == 0" style="height:500px;border-bottom:1px solid var(--border);">
        没有查到相关数据
      </BaseEmpty>

      <Spin fix v-if="loading">
        <BaseLoading />
      </Spin>
      </div>

      <div class="flex-wrap flex-right">
        <Page :current="page" v-if="counts[selected] > items.length" :total="counts[selected]" @on-change="page = $event;getData()"></Page>
      </div>
    </div>

  </div>
</template>

<script>
const urlmapper = {
  '类别': 'types',
  '品牌': 'brands',
  '材料': 'products',
  '商家': 'companies',
};
export default {
  data() {
    return {
      sub_types: ['类别', '品牌', '材料', '商家'],
      selected: '材料',
      grouped_items: {},
      counts: {},
      searchText: '',
      loading: false,
      total: 0,
      page: 1,
      pagesize: 10,
      types: [],
      products: [],
      companies: [],
      brands: [],
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.search != 'undefined') {
      this.searchText = this.$route.query.search;
      this.search();
    }
  },
  watch: {
    $route: {
      handler(v) {
        if (this.$route.query && this.$route.query.search != 'undefined') {
          this.searchText = this.$route.query.search;
          this.search();
        }
      },
      deep: true,
    },
  },
  computed: {
    items() {
      return this[urlmapper[this.selected]] || [];
    },
  },
  methods: {
    addToCart(item) {
      this.$store.commit('mat/add_cart', item);
      this.$Notice.success({title: '添加成功'});
    },
    search() {
      this.page = 1;
      this.loading = true;
      Object.keys(urlmapper).forEach((key)=>{
        this.$api.get(`mat/${urlmapper[key]}?q=count&search=${this.searchText}`).then((res)=>{
          this.$set(this.counts, key, res.data.data || 0);
        }).finally(()=>{
          setTimeout(()=>{
            this.loading = false;
          }, 1000);
        });

        this.getData();
      });
    },
    getData() {
      this.loading=true;
      const urlmapper = {
        '类别': 'types',
        '品牌': 'brands',
        '材料': 'products',
        '商家': 'companies',
      };
      this.$api.get(`mat/${urlmapper[this.selected]}?related=producer,prices,type,brand&page=${this.page}&pagesize=${this.pagesize}&search=${this.searchText}`).then((res)=>{
        const items = res.data.data;
        items.forEach((v)=>{
          if (Array.isArray(v.prices) && v.prices.length > 0) {
            v.last_price = v.prices[v.prices.length - 1];
          }
        });
        this[urlmapper[this.selected]] = items;
      }).finally((e)=>{
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
